import { ofType } from 'redux-observable';
import { concat, EMPTY, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { REFRESH_SIGNED_URLS_ENDPOINT_URL } from '@/modules/common/constants/request';

import { tmPostRequest } from '@/modules/common/helpers/request';
import {
  updateResourceAction as commonUpdateResourceAction,
  updateResourcesStartedAction,
} from '@/modules/common/redux/slices/common';
import { updateResourceAction as shareUpdateResourceAction } from '@/modules/PlayerOverview/redux/slices/share';
import { updateResourceAction as singleUpdateResourceAction } from '@/modules/PlayerOverview/redux/slices/single';
import { updateResourceAction as searchUpdateResourceAction } from '@/modules/Search/redux/slices/search';
import { updateResourceAction as searchAiUpdateResourceAction } from '@/modules/Search/redux/slices/searchAi';

export default (action$) =>
  action$.pipe(
    ofType(updateResourcesStartedAction.type),
    mergeMap(({ payload }) => {
      const reqData = payload.map(({ sourceUrl }, index) => ({
        id: index,
        path: new URL(sourceUrl).pathname,
      }));

      return tmPostRequest({
        url: REFRESH_SIGNED_URLS_ENDPOINT_URL,
        body: {
          paths: reqData,
        },
      }).pipe(
        mergeMap((data) => {
          const { status, response } = data;

          if (status === 200) {
            const resData = response.urls.reduce((acc, curr) => {
              if (curr.url) {
                const oldData = payload.find((_, payloadIndex) => payloadIndex === +curr.id);
                acc[oldData.sourceUrl] = {
                  newUrl: curr.url,
                  signedUrlExp: response.signedUrlExp,
                };
              }

              return acc;
            }, {});

            return concat(
              of(commonUpdateResourceAction(resData)),
              of(shareUpdateResourceAction(resData)),
              of(singleUpdateResourceAction(resData)),
              of(searchUpdateResourceAction(resData)),
              of(searchAiUpdateResourceAction(resData)),
            );
          }
          return EMPTY;
        }),
        catchError(() => EMPTY),
      );
    }),
  );
